<ngx-spinner bdOpacity=0.5 bdColor="rgba(0,0,0,0.84)" size="default" color="#fff" type="ball-pulse"
[fullScreen]="true"> </ngx-spinner>
<!-- <div class="row main-podcast-row">
  <div class="col-md-12">
    <h1 class="page-header">Podcasts</h1>
  </div>
</div> -->
<!-- <div class="thumb_sec">
  <div class="row">
    <div class="col-md-12">
      <h3>{{podcastCategory?.category_name}}
      </h3>
    </div>
  </div>
  <div class="row product-row">
    <div class="col-12 product-item"  *ngFor="let podcast of podcastList" >
      <a  routerLink="/podcasts-web/podcast/{{podcast?.alias}}">
        <div class="thumb_wrap">
          <div class="thumb_img"> <img alt="{{podcast?.title}}" src="{{podcast?.thumbnail}}"> </div>
          <div class="thumb_con">
            <h4>{{podcast?.title | titlecase}}</h4>
            <span>{{podcast?.description}}</span>
          </div>
        </div>
      </a>
    </div>
    <div *ngIf="podcastList.length == 0" class="cover-space">
    </div>
   
  </div>-->
  <!-- <div class="load-more-podcast" *ngIf="nextPage < podcastCategory?.total_no_of_page">
    <button (click)="loadMorePodcasts()">Load More</button>
  </div> -->
<!-- </div>  -->

<div class="col-12 all-podcast-html">
  <div class="row">
    <div class="col-12 col-lg-2 ads-space">
      <!--------------------Blank Space------------->
    </div>
    <div class="col-12 col-lg-8 center-wrapper">
      <div class="row">
        <div class="container">
          <div class="row">
            <div class="col-12 categoryList-title">
              <h3>{{podcastCategory?.category_name}}</h3>
              <div class="dropdown filter-bropdown">
                <button type="button" class="dropdown-toggle" data-toggle="dropdown">{{podcastCategory?.category_name}}</button>
                <div class="dropdown-menu">
                  <ul>
                    <li *ngFor="let cat of podcastCategoryList"><a href="javascript:void(0);" routerLink="/podcasts-web/category/{{cat?.alias}}" class="dropdown-item">{{cat?.name}}</a></li>
                    <!-- <li><a href="javascript:void(0);" class="dropdown-item">Health</a></li> -->
                    <!-- <li><a href="javascript:void(0);" class="dropdown-item">Business</a></li> -->
                    <!-- <li><a href="javascript:void(0);" class="dropdown-item">Motivational</a></li> -->
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-12 categoryList">
              <div class="row">
                <div class="col-12 col-sm-6 col-lg-4 category-item" *ngFor="let podcast of podcastList" >
                  <div class="category-inner">
                    <a routerLink="/podcasts-web/podcast/{{podcast?.alias}}">
                      <div class="card-image">
                        <img alt="{{podcast?.title}}" src="{{podcast?.thumbnail}}">
                      </div>
                    </a>
                  </div>
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-2 ads-space">
      <div class="ads-wrapper">
        <img src="assets/images/podcasts/Popular-podcasts/ads-side.jpg" alt="ads-side">
      </div>
    </div>
  </div>
</div>